<template>
    <div>
        <modal v-model:show="modal" body-classes="p-0">
            <card
                class="mb-0"
                header-classes="p-0 rounded-top"
                footer-classes="d-flex align-items-center justify-content-end"
            >
                <template #header><div
                    class="py-4 px-3"
                    :style="$bgColor(color.primary)"
                >
                    <h6
                        class="modal-title"
                        id="modal-title-default"
                        :style="{ color: color.secondary }"
                    >
                        <i class="mdi mdi-cart"></i>{{ $t('cart.cart') }}
                    </h6>
                </div></template>
                <template v-if="true">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <p class="text-center">
                            {{ $t('cart.recurrence.have_recurrence') }}.
                        </p>
                    </div>
                </template>
                <template #footer>
                    <a href="/cart" class="btn btn-outline-primary">
                        {{ $t('cart.go_to_cart') }}
                    </a>
                    <base-button
                        type="outline-primary"
                        ref="btnClear"
                        @click="clearCartAndAdd(planId)"
                        >{{ $t('cart.clear') }}
                    </base-button>
                    <base-button
                        type="danger"
                        ref="btnBack"
                        @click="el => this.modal = false"
                        >{{ $t('common.back') }}
                    </base-button>
                </template>
            </card>
        </modal>
    </div>
</template>

<script>
import Card from '../../argon/components/Cards/Card';
import Modal from '../../argon/components/Modal';
import BaseButton from '../../argon/components/BaseButton';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'CartAddRecurrence',
    components: {
        Card,
        Modal,
        BaseButton,
    },
    props: {
        modelValue: Boolean,
        planId: Number,
        recurrenceOption: Number,
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        modal: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
    },
    methods: {
        async clearCartAndAdd(id) {
            this.$loading.show();
            return window.axios
                .post(`/api/cart/add/${id}`, {
                    clear: true,
                    recurrence_option: this.recurrenceOption,
                })
                .then(res => {
                    this.$loading.close();
                    location.href = "/cart";
                })
                .catch(err => {
                    this.$notify({
                        type: 'danger',
                        message: err.response.data.error,
                    });
                    this.$loading.close();
                });
        },
    },
};
</script>

<style></style>
